import type { UrlObject } from 'url'
import { Box } from '@chakra-ui/react'

import ShwLink from '@/components/ShwLink'

interface Props {
  children: React.ReactChild
  href: string | UrlObject
  isExternal?: boolean
}

export default function SoftLink({ href, children, isExternal }: Props): React.ReactElement {
  return (
    <ShwLink href={href} width="100%" isExternal={isExternal}>
      <Box textDecoration="none" color="inherit" cursor="pointer">
        {children}
      </Box>
    </ShwLink>
  )
}
